import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import { accountAPi } from './accountsApi';

import type { IAccount } from '../accounts.types';

// Define the type for state
interface AccountState {
  accountList: IAccount[] | null;
}

const initialState: AccountState = { accountList: null };

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setAccountList: (state, action: PayloadAction<IAccount[]>) => {
      state.accountList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      .addMatcher(accountAPi.endpoints.createAccount.matchFulfilled, (state, action) => {
        state.accountList = state.accountList
          ? [...state.accountList, action.payload]
          : [action.payload];
      })
      .addMatcher(accountAPi.endpoints.updateAccount.matchFulfilled, (state, action) => {
        state.accountList = state.accountList
          ? state.accountList.map((account) =>
              account.id === action.payload.id ? action.payload : account
            )
          : [];
      })
      .addMatcher(accountAPi.endpoints.filterAccount.matchFulfilled, (state, action) => {
        state.accountList = action.payload.list;
      });
  },
});

export const { setAccountList } = accountSlice.actions;
export default accountSlice.reducer;
